import React, { Fragment, useEffect, useRef, useState } from "react"
import { Link } from "gatsby"
import TemporaryDrawer from "./SideDrawer"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Popover, Transition } from "@headlessui/react"
import { StaticImage } from "gatsby-plugin-image"
import { SearchIcon } from "@heroicons/react/outline"
import SearchModal from "./Search/SearchModal"
import SubMenu from "./Submenu"
import useWindowDimensions from "../hooks/useWindowDimensions"

function classNames(...classes) {
  return classes.filter(Boolean).join(" ")
}

const Header = props => {
  const { relative } = props
  const [searchModal, setSearchModal] = useState(false)

  function handleCloseSerchModal() {
    setSearchModal(!searchModal)

    // document.body.style.overflow = "unset"
  }

  function searchHandler() {
    setSearchModal(!searchModal)
  }

  function doSomething() {
    const element = document.getElementById("mainContent")
    const check = element.classList
    if (check.contains("blurAhah")) {
      element.classList.remove("blurAhah")
    } else {
      element.classList.add("blurAhah")
    }
  }

  return (
    <HeaderStyles relative={relative} id="mainheader" className="relative">
      <SocialIcons />
      <NavStyles
        relative={relative}
        className="shadow w-full border-b-1 mx-auto"
      >
        <ul className="mainUl">
          <li className="z-[100]">
            <Link
              to="/news/"
              activeStyle={{
                color: "var(--red)",
              }}
            >
              News
            </Link>
          </li>
          <li className="ourwines z-20">
            <Popover className="flex">
              {({ open }) => (
                <>
                  {/* {!open && removeBlur()} */}

                  <Popover.Button
                    // onClick={() => doSomething()}
                    className={classNames(
                      open
                        ? "text-red-700 focus:outline-none relative z-20"
                        : "relative z-10 flex items-center focus:outline-none transition-colors ease-out duration-200 submenu2"
                    )}
                  >
                    Our Wineries
                  </Popover.Button>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Popover.Panel className="absolute top-full inset-0 ">
                      <SubMenu />
                      <Popover.Overlay
                        className={`fixed inset-0 w-full roger`}
                      />
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>
          </li>
          <li className="z-20">
            <Link
              to="/us-partners/"
              activeStyle={{
                color: "var(--red)",
              }}
            >
              Our Partners
            </Link>
          </li>
          <li className="overwrite z-20">
            <Link to="/">
              <ImgStyles>
                {relative ? (
                  <StaticImage
                    src="../images/LOGO-BLS-2020-BLC.png"
                    layout="fixed"
                    height={140}
                    width={280}
                    loading="eager"
                    className="logo"
                    alt="bruno lafon selection logo"
                  />
                ) : (
                  <StaticImage
                    src="../images/LOGO-BLS-2020-REG.jpg"
                    layout="fixed"
                    height={140}
                    width={280}
                    loading="eager"
                    className="logo"
                    alt="bruno lafon selection logo"
                  />
                )}
              </ImgStyles>
            </Link>
          </li>
          <li className="z-20">
            <Link
              to="/about-us/"
              activeStyle={{
                color: "var(--red)",
              }}
            >
              About Us
            </Link>
          </li>
          <li className="z-20">
            <Link
              to="/contact/"
              activeStyle={{
                color: "var(--red)",
              }}
            >
              Contact Us
            </Link>
          </li>
          <li className="ml-2 p-2 z-20">
            {!searchModal ? (
              <button
                className="justify-between w-full	 flex text-white bg-red-700 hover:bg-red-800 focus:outline-none rounded-lg px-5 py-2.5 text-center"
                type="button"
                onClick={() => {
                  searchHandler()
                }}
              >
                <span className="sr-only">Search</span>
                <p className="ml-2 text-base text-white">SEARCH</p>
                <SearchIcon className="w-6 h-6 mr-2" aria-hidden="true" />
              </button>
            ) : (
              <button
                type="button"
                className=" text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                onClick={() => handleCloseSerchModal()}
              >
                <svg
                  className="w-10 h-10"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            )}
          </li>
        </ul>
      </NavStyles>
      <Visible>
        <TemporaryDrawer SearchOpen={searchHandler} />
      </Visible>
      {searchModal && <SearchModal handleClose={handleCloseSerchModal} />}
    </HeaderStyles>
  )
}

export const WinesDropDown = styled.div`
  /* height: 0 !important;
  z-index: -50; */
  display: none;
  opacity: 0;
  a {
    color: #3a3a3a !important;
    &:hover {
      color: var(--red);
    }
    &:active {
      color: var(--red);
    }
  }
`

export const HeaderStyles = styled.header`
  margin: 0 auto;
  z-index: 300;
  width: 100%;
  position: ${props => (props.relative === true ? `absolute` : `relative`)};
  background: ${props => props.relative === false && `#00000`};

  top: 0;
  opacity: 1;

  @media only screen and (max-width: 900px) {
    position: absolute;
    height: 100px;
  }
`
export const ImgStyles = styled.div`
  margin: 0 2rem;

  padding: 10px 0;
  display: flex;
  justify-content: center;
  .logo {
    opacity: 1 !important;
    margin: 0 auto;
    width: 140px !important;
    height: 70px !important ;
  }
  @media only screen and (max-width: 900px) {
  }
`
const Visible = styled.div`
  visibility: hidden;
  display: none;
  @media only screen and (max-width: 900px) {
    visibility: visible;
    height: 0;
    display: block;
    .MuiButtonBase-root {
      position: "fixed";
      width: "32px";
      height: "32px";
      top: "50px";
      right: "40px";
    }
  }
`

const NavStyles = styled.nav`
  z-index: 300;
  .submenu2 {
    padding: 0 !important;
    color: #3a3a3a !important;
  }
  .submenu2:hover {
    color: var(--red) !important;
  }

  height: 100px;
  font-family: var(--ff-nav) !important;
  visibility: visible;

  #headerB {
    font-size: 15px;
    text-transform: none;
    color: ${props =>
      props.relative === true ? `#FFFFFF` : `rgba(0, 0, 0, 0.87)`};
  }

  .ourwines {
    height: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  .roger {
    //height: ${props => props.height};
    backdrop-filter: blur(4px);
    z-index: 1;
  }

  li {
    width: 140px;
  }

  .overwrite {
    width: 280px !important;
  }

  .mainUl {
    height: 100%;
    max-width: 980px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    text-align: center;
    list-style: none;
    align-items: center;
  }
  a {
    color: ${props => (props.relative === true ? `#FFFFFF` : `#3A3A3A`)};
    font-weight: 400;
    font-size: 1.2rem;
    text-decoration: none;
    transition: background-size 0.3s;
    li {
      box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
        0 2px 4px -2px rgb(0 0 0 / 0.1);
    }
    &:hover {
      background-color: transparent;
      color: var(--red);
    }
    &.active {
      color: var(--red);
      box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
        0 2px 4px -2px rgb(0 0 0 / 0.1);
    }
  }

  @media only screen and (max-width: 900px) {
    visibility: hidden;
    .mainUl {
      width: 200px;
    }
    li {
      width: 0;
    }
  }
`

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header

const SocialIcons = () => {
  return (
    <div className="socialHeader z-[100] flex justify-center items-center absolute top-0 -mt-[2px] h-[100px] px-8">
      <a
        href={`https://www.linkedin.com/company/bruno-lafon-selection/`}
        target="_blank"
        rel="noreferrer"
        alt="bruno lafon linkedin"
        className="hover:opacity-80 z-20"
      >
        <Linkedin />
      </a>
      <div className="ml-2">
        <a
          href={`https://www.instagram.com/brunolafonselection/`}
          target="_blank"
          rel="noreferrer"
          alt="bruno lafon instagram"
          className="hover:opacity-80 z-20"
        >
          <Instagram />
        </a>
      </div>
    </div>
  )
}

const Instagram = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <defs>
      <radialGradient
        id="a"
        gradientUnits="userSpaceOnUse"
        cx={158.429}
        cy={578.088}
        fx={158.429}
        fy={578.088}
        r={65}
        gradientTransform="matrix(0 -.36036 .33526 0 -187.345 82.728)"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#fd5",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.1}
          style={{
            stopColor: "#fd5",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.5}
          style={{
            stopColor: "#ff543e",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#c837ab",
            stopOpacity: 1,
          }}
        />
      </radialGradient>
      <radialGradient
        id="b"
        gradientUnits="userSpaceOnUse"
        cx={147.694}
        cy={473.455}
        fx={147.694}
        fy={473.455}
        r={65}
        gradientTransform="matrix(.03163 .15795 -.65124 .1304 299.882 -83.18)"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#3771c8",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={0.128}
          style={{
            stopColor: "#3771c8",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#60f",
            stopOpacity: 0,
          }}
        />
      </radialGradient>
    </defs>
    <path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "url(#a)",
      }}
      d="M12.008.184c-4.938 0-6.38.004-6.66.027C4.336.293 3.703.453 3.02.797c-.532.262-.95.566-1.36.992C.91 2.57.457 3.527.29 4.664c-.08.555-.102.668-.106 3.488-.004.942 0 2.18 0 3.844 0 4.93.004 6.371.027 6.652.082.985.238 1.606.566 2.282a4.962 4.962 0 0 0 3.227 2.636c.484.125 1.023.196 1.715.227.293.016 3.277.023 6.261.023 2.985 0 5.973-.003 6.258-.02.801-.034 1.262-.097 1.778-.23a4.95 4.95 0 0 0 3.226-2.644c.32-.66.485-1.305.559-2.238.015-.204.023-3.45.023-6.692s-.008-6.484-.023-6.687c-.074-.95-.238-1.59-.57-2.262a4.63 4.63 0 0 0-1.012-1.387C21.437.91 20.48.453 19.339.29c-.55-.078-.66-.101-3.487-.105Zm0 0"
    />
    <path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "url(#b)",
      }}
      d="M12.008.184c-4.938 0-6.38.004-6.66.027C4.336.293 3.703.453 3.02.797c-.532.262-.95.566-1.36.992C.91 2.57.457 3.527.29 4.664c-.08.555-.102.668-.106 3.488-.004.942 0 2.18 0 3.844 0 4.93.004 6.371.027 6.652.082.985.238 1.606.566 2.282a4.962 4.962 0 0 0 3.227 2.636c.484.125 1.023.196 1.715.227.293.016 3.277.023 6.261.023 2.985 0 5.973-.003 6.258-.02.801-.034 1.262-.097 1.778-.23a4.95 4.95 0 0 0 3.226-2.644c.32-.66.485-1.305.559-2.238.015-.204.023-3.45.023-6.692s-.008-6.484-.023-6.687c-.074-.95-.238-1.59-.57-2.262a4.63 4.63 0 0 0-1.012-1.387C21.437.91 20.48.453 19.339.29c-.55-.078-.66-.101-3.487-.105Zm0 0"
    />
    <path
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#fff",
        fillOpacity: 1,
      }}
      d="M12 3.273c-2.371 0-2.668.008-3.598.051-.93.043-1.562.192-2.117.406a4.281 4.281 0 0 0-1.547 1.008A4.3 4.3 0 0 0 3.73 6.281c-.214.559-.363 1.192-.406 2.121-.039.93-.05 1.227-.05 3.598 0 2.371.011 2.668.05 3.598.043.93.192 1.562.406 2.117a4.281 4.281 0 0 0 1.008 1.547 4.3 4.3 0 0 0 1.543 1.008c.559.214 1.192.363 2.121.406.93.043 1.227.05 3.598.05 2.371 0 2.668-.007 3.598-.05.93-.043 1.562-.192 2.117-.406a4.281 4.281 0 0 0 1.547-1.008 4.281 4.281 0 0 0 1.008-1.547c.214-.555.359-1.188.406-2.117.039-.93.05-1.227.05-3.598 0-2.371-.011-2.668-.05-3.598-.047-.93-.192-1.562-.406-2.117a4.281 4.281 0 0 0-1.008-1.547 4.23 4.23 0 0 0-1.547-1.008c-.555-.214-1.192-.363-2.117-.406-.934-.043-1.23-.05-3.602-.05Zm-.781 1.57H12c2.332 0 2.605.012 3.527.052.852.039 1.313.183 1.621.3.407.16.696.348 1.004.653.305.308.493.597.653 1.004.117.308.261.77.3 1.62.04.919.051 1.196.051 3.524 0 2.332-.011 2.606-.05 3.527-.04.852-.184 1.313-.301 1.622-.16.406-.348.695-.653 1a2.674 2.674 0 0 1-1.004.652c-.308.121-.77.262-1.62.3-.923.044-1.196.051-3.528.051-2.328 0-2.605-.007-3.527-.05-.848-.04-1.313-.18-1.618-.301-.41-.156-.699-.344-1.003-.652a2.686 2.686 0 0 1-.657-1c-.117-.31-.261-.77-.3-1.622-.04-.921-.047-1.195-.047-3.527s.007-2.605.047-3.527c.039-.848.183-1.313.3-1.617.16-.41.348-.7.657-1.004a2.67 2.67 0 0 1 1.003-.657c.305-.117.77-.261 1.618-.3.804-.036 1.117-.047 2.746-.047Zm5.441 1.45c-.578 0-1.047.469-1.047 1.047s.469 1.05 1.047 1.05a1.05 1.05 0 0 0 1.047-1.05c0-.578-.469-1.047-1.047-1.047ZM12 7.52a4.48 4.48 0 1 0 0 8.96 4.48 4.48 0 0 0 0-8.96Zm0 1.57A2.912 2.912 0 0 1 14.91 12 2.912 2.912 0 0 1 12 14.91 2.912 2.912 0 0 1 9.09 12 2.912 2.912 0 0 1 12 9.09Zm0 0"
    />
  </svg>
)

const Linkedin = () => (
  <svg fill="currentColor" width="30" height="30" viewBox="0 0 48 48">
    <path
      fill="#0288D1"
      d="M42,37c0,2.762-2.238,5-5,5H11c-2.761,0-5-2.238-5-5V11c0-2.762,2.239-5,5-5h26c2.762,0,5,2.238,5,5V37z"
    ></path>
    <path
      fill="#FFF"
      d="M12 19H17V36H12zM14.485 17h-.028C12.965 17 12 15.888 12 14.499 12 13.08 12.995 12 14.514 12c1.521 0 2.458 1.08 2.486 2.499C17 15.887 16.035 17 14.485 17zM36 36h-5v-9.099c0-2.198-1.225-3.698-3.192-3.698-1.501 0-2.313 1.012-2.707 1.99C24.957 25.543 25 26.511 25 27v9h-5V19h5v2.616C25.721 20.5 26.85 19 29.738 19c3.578 0 6.261 2.25 6.261 7.274L36 36 36 36z"
    ></path>
  </svg>
)
